import { Injectable } from '@angular/core';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { MetaElementUsageIdentityVO } from '@shared/vo/meta-element.vo';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ArticleContainerAttachedService  {

  private _attachedArticleContainer$ = new Subject<AttachedArticleContainer>();

  public get attachedArticleContainer$(): Observable<AttachedArticleContainer> {
    return this._attachedArticleContainer$.asObservable();
  }

  public setArticleContainerAttached(data: AttachedArticleContainer): void {
    this._attachedArticleContainer$.next(data);
  }
}

export interface AttachedArticleContainer {
  articleGUID: string,
  compositionId: string,
  container: ArticleContainer,
  connectedTo: MetaElementUsageIdentityVO[]
}
